
import Video from "../../../assets/outline/Video.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoIcon({ className, dataTestid = "VideoIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Video data-testid={dataTestid} className={classes} {...rest} />
  );
}
